import React from 'react';
import { Helmet } from 'react-helmet-async';
import Banner from '../components/common/Banner';
import PortfolioFilter from '../components/portfolio/PortfolioFilter';
import PortfolioGallery from '../components/portfolio/PortfolioGallery';
import FeaturedProject from '../components/portfolio/FeaturedProject';
import SuccessStats from '../components/portfolio/SuccessStats';
import PartnerLogos from '../components/portfolio/PartnerLogos';

const PortfolioPage = () => {
  return (
    <>
      <Helmet>
        <title>Portfolio - KALS Academy</title>
        <meta name="description" content="Explore our projects, student success stories, research work, and achievements. See how KALS Academy has contributed to the field of structural engineering." />
      </Helmet>
      
      <Banner title="Our Portfolio" />
      <PortfolioFilter />
      <PortfolioGallery />
      <FeaturedProject />
      <SuccessStats />
      <PartnerLogos />
    </>
  );
};

export default PortfolioPage;
